import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { UserTasksComponent } from '../user-tasks/user-tasks.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';

@Component({
    selector: 'app-user-tasks-dialog',
    templateUrl: './user-tasks-dialog.component.html',
    styleUrl: './user-tasks-dialog.component.scss',
    imports: [
        UserTasksComponent,
    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class UserTasksDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }
}
